import LogoutButton from '@pages/Dashboard/components/LogoutButton'
import styles from '../dashboard.module.css'
import habitatLogo from '../../../assets/habitat-logo.svg'
import { Stack, Tooltip } from '@mui/material'
import { DateTime } from 'luxon'

/*
 * Which build you are looking at.
 *
 * The version is the date, so it cannot tell two deploys apart on its own.
 * Four builds went out on 1 September all calling themselves 2026.09.01, and
 * from the screen they were indistinguishable, which made an afternoon of
 * "is this fixed yet" much harder than it needed to be.
 *
 * This describes the commit the bundle was built from, not the moment it was
 * built, so every instance serving a deploy reports the same thing. A build
 * made outside a deploy archive has no stamp and reads as unknown. See
 * vite.config.ts.
 */
const buildStamp = DateTime.fromISO(__BUILD_TIME__)
const shortCommit = __BUILD_COMMIT__.slice(0, 7)

/*
 * The version is the date, so repeating the date next to it says nothing. On
 * the usual day, when a build goes out under a version stamped the same day,
 * only the time is worth showing.
 *
 * They do come apart. Deploy again tomorrow without bumping the version and
 * the version still reads 2026.09.01 while the build is the 2nd, which is
 * precisely when the date earns its place. So it appears only then.
 */
const versionDate = DateTime.fromFormat(__APP_VERSION__, 'yyyy.MM.dd')
const sameDay =
    versionDate.isValid &&
    buildStamp.isValid &&
    versionDate.hasSame(buildStamp, 'day')

// The whole line, prefix included, so the unknown case does not read
// "built build time unknown".
const buildLine = !buildStamp.isValid
    ? 'build time unknown'
    : sameDay
      ? `built ${buildStamp.toFormat('HH:mm')}`
      : `built ${buildStamp.toFormat('d LLL HH:mm')}`

/*
 * The header line has room for a time. The tooltip has room for the commit,
 * which is the thing that actually names a build: two deploys on the same day
 * share a date, but never a SHA.
 */
const buildTooltip = [
    buildStamp.isValid
        ? `Built ${buildStamp.toFormat('DDD, HH:mm:ss ZZZZ')}`
        : 'Build time unknown',
    shortCommit ? `commit ${shortCommit}` : '',
]
    .filter(Boolean)
    .join(', ')

const DashboardHeader = () => {
    return (
        <div className={styles.header}>
            <div className={styles.headerInner}>
                <img
                    src={habitatLogo}
                    style={{
                        width: '40px',
                    }}
                />
                <Stack>
                    <h1 className={styles.headerLogotype}>Staff Console</h1>

                    <span className={styles.headerLogotypeSmall}>
                        By Habitat Learn
                    </span>
                </Stack>
            </div>
            <Stack direction="row" alignItems="center" spacing={2}>
                <Tooltip title={buildTooltip}>
                    <Stack className={styles.headerVersion}>
                        <span>v{__APP_VERSION__}</span>
                        <span>{buildLine}</span>
                    </Stack>
                </Tooltip>
                <LogoutButton />
            </Stack>
        </div>
    )
}

export default DashboardHeader
